<template>
  <b-row align-v="center">
    <b-col cols="12" v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col cols="12" v-else>
      <b-row>
        <b-col cols="12">
          <p>Dozwolone formaty: .txt, .csv, .xls, xlsx, .json</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file browse-text="Przeglądaj" ref="file-input" name="document" accept=".docx, .csv, .txt, .xml, .json" v-model="dataFile" :state="Boolean(document)" :placeholder="'Przeciągnij i upuść plik lub kliknij przeglądaj'"></b-form-file>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-btn @click="submitFile()">{{ $t('buttons.submit') }}</b-btn>
          <button type="button" class="btn btn-warning" @click="clearFiles()">{{ $t('buttons.clear') }}</button>
          <button type="button" class="btn btn-danger float-right" @click="clearContractorData()">{{ $t('buttons.clearContractorData') }}</button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

import Loader from '@/components/Dashboard/Layout/Loader'
import ApiService from '@/utils/ApiService'
export default {
  name: 'UploadDocumentModal',
  components: { Loader },
  computed: {
  },
  data () {
    return {
      dataFile: '',
      isLoading: false
    }
  },
  methods: {
    clearFiles () {
      this.$refs['file-input'].reset()
    },
    submitFile () {
      this.isLoading = true
      let formData = new FormData()
      formData.append('dataFile', this.dataFile)
      this.$http.post('api/upload_contractors_data_from_file',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.status === 201) {
          this.$Swal({
            type: 'success',
            title: this.$t('notifications.update.updatedTitle'),
            timer: 2500
          })
          this.$router.push({ name: 'FirmList' })
        } else if (response.status === 207) {
          let text = ''
          for (let i in response.data) {
            text += response.data[i] + '\n'
          }
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
        this.isLoading = false
      }).catch(error => {
        if (error.response.status === 400) {
          let text = error.response.data['hydra:description']
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
        console.log(error)
        this.isLoading = false
      })
    },
    resetData () {
      this.dataFile = ''
    },
    clearContractorData () {
      this.$Swal({
        title: this.$t('notifications.dataUpload.clearContractorData'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(() => {
        new ApiService(`delete_contractors`).put({})
      })
    }
  }
}
</script>
